var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmationUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_11_1371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M51.0554 22.7601V46.6273C51.0554 49.5929 48.6484 52 45.6828 52H6.30698C3.34136 52 0.934326 49.5929 0.934326 46.6273V22.7601L22.2117 1.56401C24.3039 -0.528174 27.696 -0.528174 29.7984 1.56401L51.0554 22.7601Z",
    fill: "#FF9D00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5117 5.98193H41.539C44.5047 5.98193 46.9117 8.38896 46.9117 11.3546V42.3819C46.9117 45.3476 44.5047 47.7546 41.539 47.7546H10.5117C7.54607 47.7546 5.13904 45.3476 5.13904 42.3819V11.3444C5.13904 8.37881 7.54607 5.98193 10.5117 5.98193Z",
    fill: "#F4EEE6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M51.0554 22.76V46.6272C51.0554 49.5928 48.6484 51.9999 45.6828 51.9999H6.30698C3.34136 51.9999 0.934326 49.5928 0.934326 46.6272V22.8311L25.9593 47.8561L51.0554 22.76Z",
    fill: "#FFBE1D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M49.5015 50.4156C48.6586 51.2687 47.5211 51.8374 46.2617 51.9796L6.12419 52C4.71248 51.9492 3.43279 51.3499 2.49841 50.4156L22.2015 30.7125C24.2937 28.6203 27.6961 28.6203 29.7984 30.7125L49.5015 50.4156Z",
    fill: "#FFE000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M25.9999 26.5079C30.9416 26.5079 34.9476 22.5019 34.9476 17.5602C34.9476 12.6186 30.9416 8.61255 25.9999 8.61255C21.0582 8.61255 17.0522 12.6186 17.0522 17.5602C17.0522 22.5019 21.0582 26.5079 25.9999 26.5079Z",
    fill: "#00BF00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M31.1288 13.7312C30.7835 13.3858 30.2147 13.3858 29.8593 13.7312L24.1108 19.4796L22.1101 17.4788C21.7749 17.1437 21.2163 17.1437 20.8812 17.4788L20.8608 17.4991C20.5054 17.8546 20.5054 18.4233 20.8608 18.7687L23.471 21.3788C23.8163 21.7241 24.3851 21.7241 24.7405 21.3788L31.1288 14.9905C31.4843 14.6452 31.4843 14.0765 31.1288 13.7312Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_1371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationUploadIcon);
export default __webpack_public_path__ + "static/media/confirmation-upload-icon.b381c1dd6d7043d66f163f65a52bc427.svg";
export { ForwardRef as ReactComponent };